import { jsxs, jsx } from "react/jsx-runtime";
const IconVisibilityOutlineSvg = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ jsxs(
  "svg",
  {
    width: 16,
    height: 16,
    viewBox: "0 0 18 12",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    "aria-labelledby": titleId,
    ...props,
    children: [
      title ? /* @__PURE__ */ jsx("title", { id: titleId, children: title }) : null,
      /* @__PURE__ */ jsx("path", { d: "M17.26 5.658C17.16 5.434 14.723.167 9 .167S.84 5.434.74 5.658a.834.834 0 0 0 0 .684c.1.224 2.537 5.491 8.26 5.491s8.16-5.267 8.26-5.491a.834.834 0 0 0 0-.684ZM9 10.167C5.077 10.167 3.023 7.06 2.436 6 3.023 4.94 5.076 1.833 9 1.833c3.925 0 5.98 3.108 6.564 4.167-.587 1.06-2.64 4.167-6.564 4.167Z" }),
      /* @__PURE__ */ jsx("path", { d: "M9 8.083a2.083 2.083 0 1 0 0-4.166 2.083 2.083 0 0 0 0 4.166Z" })
    ]
  }
);
export {
  IconVisibilityOutlineSvg
};
